import styled, { css } from "styled-components";
import { SPACING, ANIMATION, FONTS } from "../../../../../utils/constants";

export const CompositionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  background: var(--color-card-background);
  border: 1px solid var(--color-card-border);
  border-radius: 12px;
  padding: ${SPACING.md}px ${SPACING.lg}px;
  box-shadow: var(--shadow-card-rest);
`;

export const CompositionTitle = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
`;

export const Bar = styled.div`
  position: relative;
  width: 100%;
  height: 16px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--color-border);
`;

export const BarSegment = styled.div<{
  $width: number;
  $offset: number;
  $color: string;
}>`
  position: absolute;
  inset: 0;
  transform-origin: left center;
  /* Placed and sized by transform alone: an animated width would relayout the bar on every frame. */
  transform: translateX(${({ $offset }) => $offset}%)
    scaleX(${({ $width }) => $width / 100});
  background: ${({ $color }) => $color};
  transition: transform ${ANIMATION.duration.moderate}
    ${ANIMATION.easing.easeOut};
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LegendRow = styled.div<{ $divided?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
  padding: ${SPACING.sm}px 0;
  ${({ $divided }) =>
    $divided
      ? css`
          border-top: 1px solid var(--color-border);
          margin-top: ${SPACING.xs}px;
          padding-top: ${SPACING.sm + SPACING.xs}px;
        `
      : ""}
`;

export const LegendLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
`;

export const Swatch = styled.span<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const LegendName = styled.span`
  font-size: var(--text-md);
  color: var(--color-text-default);
`;

export const LegendValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${SPACING.sm}px;
`;

export const LegendAmount = styled.span<{ $color?: string }>`
  font-family: ${FONTS.serif};
  font-size: var(--text-md);
  font-weight: 700;
  color: ${({ $color }) => $color ?? "var(--color-text-default)"};
  white-space: nowrap;
`;

export const LegendPercent = styled.span`
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--color-text-secondary);
  min-width: 2.5ch;
  text-align: right;
`;
